import React, { useMemo, useState } from 'react';
import { Loader2, Search } from 'lucide-react';
import DiscoverTeamCard from './DiscoverTeamCard';
import { useAdminTeams } from '../../../hooks';

const DiscoverTeamSection = () => {
  const [filterName, setFilterName] = useState('');

  const searchQuery = useMemo(
    () => ({
      team_type: 'admin_created',
      platform_id: process.env.REACT_APP_PLATFORM_ID || 'agentcy',
    }),
    [],
  );

  const getAllTeamsData = useAdminTeams(searchQuery);
  const teams = getAllTeamsData?.data?.teams || [];

  return (
    <div>
      <div className="relative mb-4">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-mute pointer-events-none" />
        <input
          type="text"
          value={filterName}
          onChange={e => setFilterName(e.target.value)}
          placeholder="Search teams"
          className="w-full bg-white border border-shell-border rounded-xl pl-10 pr-3 py-2.5 text-sm text-ink placeholder:text-mute outline-none focus:border-ink/30"
        />
      </div>

      <div className="space-y-3">
        {getAllTeamsData?.isPending ? (
          <div className="flex justify-center py-16">
            <Loader2 className="w-5 h-5 animate-spin text-space" />
          </div>
        ) : teams.length === 0 ? (
          <div className="py-16 text-center text-mute text-sm">No official teams found.</div>
        ) : (
          <DiscoverTeamCard teamCardsData={teams} filterName={filterName} />
        )}
      </div>
    </div>
  );
};

export default DiscoverTeamSection;
